/**
 * The Owner's read of early-access requests from the Coming Soon page.
 *
 * One paged listing under `/admin`, newest first. The server refuses anybody
 * who is not a signed-in Owner; this adapter shapes the page and nothing
 * else.
 */

import { request } from './request.js';

export interface EarlyAccessRequestRecord {
  readonly id: string;
  readonly name: string;
  readonly email: string;
  readonly brand: string;
  /** An absolute http/https URL or an `@handle`, or `null`. */
  readonly link: string | null;
  readonly language: 'en' | 'ar';
  readonly source: 'coming-soon-landing';
  /** ISO 8601, the server's clock. */
  readonly createdAt: string;
  /** Opaque; pass as `after` for the page below this row. */
  readonly cursor: string;
}

export interface EarlyAccessRequestPage {
  readonly requests: readonly EarlyAccessRequestRecord[];
  readonly nextCursor: string | null;
}

export const EARLY_ACCESS_PAGE_SIZE = 50;

export function fetchEarlyAccessRequests(
  options: {
    readonly after?: string | null;
    readonly signal?: AbortSignal;
  } = {},
): Promise<EarlyAccessRequestPage> {
  const query = new URLSearchParams({ limit: String(EARLY_ACCESS_PAGE_SIZE) });
  if (options.after !== undefined && options.after !== null)
    query.set('after', options.after);
  return request<EarlyAccessRequestPage>(
    'GET',
    `/admin/early-access-requests?${query.toString()}`,
    options.signal === undefined ? {} : { signal: options.signal },
  );
}
